import { withStyles as muiWithStyles } from "@mui/styles";

/**
 * withStyles HOC wrapper for styling components.
 * Wraps Material-UI withStyles for consistent imports.
 * 
 * @example
 * const StyledComponent = withStyles(styles)(Component);
 */
export const withStyles = muiWithStyles;

export default withStyles;
